<template>
  <div id="bookAppointment" class="relative">
    <div id="bivalentAppointment" class="pt-10">
      <title-w-star :title="t('bivalentVaccine.appointment')" titleColor="#603813" :starIconObj="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg' }" />
      <div id="bivalentVaccineAppointmentFormFrame" class="font-jost bg-grey-background m-14 p-20 rounded-3xl text-lg">
        <div class="flex space-x-14 items-center">
          <label class="radio-container"
            >{{ t("bivalentVaccine.personal") }}
            <input type="radio" name="formType" value="personal" v-model="formType" />
            <span class="checkmark"></span>
          </label>
          <label class="radio-container"
            >{{ t("bivalentVaccine.group") }}
            <input type="radio" name="formType" value="group" v-model="formType" />
            <span class="checkmark"></span>
          </label>
          <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="formTypeError">{{ formTypeError }}</span>
        </div>

        <PersonalAppointment v-if="formType == 'personal'" />
        <GroupAppointment v-else />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHeaderStore } from "@/stores/header";
import { useBivalentVaccineStore } from "@/stores/bivalentVaccine";
import { computed, onMounted, ref, toRefs } from "vue";
import { useForm, useField } from "vee-validate";
import { object, string, boolean } from "yup";
import { useRouter } from "vue-router";
import { useCommonStore } from "@/stores/common";
import moment from "moment";
import { useI18n } from "vue-i18n";
//import ContactBtnGrp from "@/components/shared/ContactBtnGrp.vue";
import PersonalAppointment from "@/components/bivalentVaccine/PersonalAppointment.vue";
import GroupAppointment from "@/components/bivalentVaccine/GroupAppointment.vue";

//import zhCn from "element-plus/lib/locale/lang/zh-cn";

const headerStore = useHeaderStore();
const bivalentVaccineStore = useBivalentVaccineStore();
const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;
// Define a validation schema
const schema = computed(() => {
  return object({
    formType: string().required(t("bivalentVaccine.formTypeRequired")),
    option: string().required(t("bivalentVaccine.optionRequired")),
    name: string().required(t("bivalentVaccine.nameRequired")),
    phoneNumber: string().required(t("bivalentVaccine.phoneNumberRequired")).matches(phoneRegExp, t("bivalentVaccine.phoneNumberInvalid")),
    age: string().required(t("bivalentVaccine.ageRequired")),
    covidRecoveryDate: string().required(t("bivalentVaccine.covidRecoveryDateRequired")),
    introducerID: string(),
    noOfPeople: string().required(t("bivalentVaccine.pleaseSelectNoOfPeople")),
    agreement: boolean().oneOf([true], t("bivalentVaccine.agreementRequired")),
  });
});
// Create a form context with validation schema
const { handleSubmit, isSubmitting, meta } = useForm({
  validationSchema: schema,
  initialValues: {
    formType: "personal",
    option: "selfPayingVaccine",
    name: "",
    phoneNumber: "",
    age: "",
    covidRecoveryDate: "",
    introducerID: "",
    noOfPeople: "",
    agreement: false,
  },
});

const { value: formType, errorMessage: formTypeError } = useField<string>("formType");
const { value: option, errorMessage: optionError } = useField<string>("option");
const { value: name, errorMessage: nameError } = useField<string>("name");
const { value: phoneNumber, errorMessage: phoneNumberError } = useField<string>("phoneNumber");
const { value: age, errorMessage: ageError } = useField<string>("age");
const { value: covidRecoveryDate, errorMessage: covidRecoveryDateError } = useField<string>("covidRecoveryDate");
const { value: introducerID, errorMessage: introducerIDError } = useField<string>("introducerID");
const { value: noOfPeople, errorMessage: noOfPeopleError } = useField<string>("noOfPeople");
const { value: agreement, errorMessage: agreementError } = useField<string>("agreement");

const sendMsg = handleSubmit(async (values, actions) => {
  let detail = {
    contactEntryPoint: headerStore.routerName,
    title: t("bivalentVaccine.bookVaccineAppointment"),
    formType: formType.value == "personal" ? t("bivalentVaccine.personal") : t("bivalentVaccine.group"),
    option: option.value == "selfPayingVaccine" ? t("bivalentVaccine.selfPayingVaccine") : "",
    name: name.value,
    phoneNumber: phoneNumber.value,
    age: t("bivalentVaccine." + age.value),
    covidRecoveryDate: t("bivalentVaccine." + covidRecoveryDate.value),
    introducerID: introducerID.value,
    noOfPoeple: noOfPeople.value,
    agreement: agreement.value,
  };

  console.log("sendMsg", detail);

  detail.message =
    "類別: " +
    detail.formType +
    "<br />" +
    "項目: " +
    detail.option +
    "<br />" +
    "姓別: " +
    detail.name +
    "<br />" +
    "手機: " +
    detail.phoneNumber +
    "<br />" +
    "年齡: " +
    detail.age +
    "<br />" +
    "距離最近一次新冠康復: " +
    detail.covidRecoveryDate +
    "<br />" +
    "介紹人編號 (如有): " +
    detail.introducerID +
    "<br />";

  //replace \n to <br> for new line

  var isSuccess = await bivalentVaccineStore.bookAppointment(detail);
  console.log("isSuccess?" + isSuccess);
  if (isSuccess) actions.resetForm();
});
</script>

<style scoped>
.el-input {
  width: 33.333333% !important;
}
.drop-down-group .group-name {
  color: #c4c4c4;
}
</style>